/**
 * @generated SignedSource<<8d55e5095d1fa85d032ee7632b5dd453>>
 * @relayHash 05a2ed7d721b148ddc8e144174362983
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 51c1ca272a2d8244b60ffb536d476ff6d2c010a24bf4a1a173cf9df601a5ce72

import type { ConcreteRequest } from 'relay-runtime';
export type TemplateListCurrentSpaceQuery$variables = {
  isLicensed: boolean;
  sortingScheme?: string | null | undefined;
  spaceKey: string;
  teamType?: string | null | undefined;
};
export type TemplateListCurrentSpaceQuery$data = {
  readonly allTemplates: {
    readonly nodes: ReadonlyArray<{
      readonly author: string | null | undefined;
      readonly blueprintModuleCompleteKey: string | null | undefined;
      readonly categoryIds: ReadonlyArray<string | null | undefined>;
      readonly contentBlueprintId: string | null | undefined;
      readonly darkModeIconURL: string | null | undefined;
      readonly description: string | null | undefined;
      readonly hasGlobalBlueprintContent: boolean;
      readonly hasWizard: boolean | null | undefined;
      readonly iconURL: string | null | undefined;
      readonly isFavourite: boolean | null | undefined;
      readonly isNew: boolean | null | undefined;
      readonly isPromoted: boolean | null | undefined;
      readonly itemModuleCompleteKey: string | null | undefined;
      readonly keywords: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly name: string | null | undefined;
      readonly recommendationRank: number | null | undefined;
      readonly styleClass: string | null | undefined;
      readonly templateId: string | null | undefined;
      readonly templateType: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    } | null | undefined;
  } | null | undefined;
  readonly userPreferences?: {
    readonly favouriteTemplateEntityIds: ReadonlyArray<string | null | undefined>;
  } | null | undefined;
};
export type TemplateListCurrentSpaceQuery = {
  response: TemplateListCurrentSpaceQuery$data;
  variables: TemplateListCurrentSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLicensed"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortingScheme"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamType"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "sortingScheme",
        "variableName": "sortingScheme"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "teamType",
        "variableName": "teamType"
      }
    ],
    "concreteType": "PaginatedTemplateInfoList",
    "kind": "LinkedField",
    "name": "allTemplates",
    "plural": false,
    "selections": [
      {
        "concreteType": "TemplateInfo",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "templateId"
          },
          {
            "kind": "ScalarField",
            "name": "contentBlueprintId"
          },
          {
            "kind": "ScalarField",
            "name": "blueprintModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "itemModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "templateType"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "iconURL"
          },
          {
            "kind": "ScalarField",
            "name": "darkModeIconURL"
          },
          {
            "kind": "ScalarField",
            "name": "styleClass"
          },
          {
            "kind": "ScalarField",
            "name": "hasWizard"
          },
          {
            "kind": "ScalarField",
            "name": "isNew"
          },
          {
            "kind": "ScalarField",
            "name": "isPromoted"
          },
          {
            "kind": "ScalarField",
            "name": "isFavourite"
          },
          {
            "kind": "ScalarField",
            "name": "hasGlobalBlueprintContent"
          },
          {
            "kind": "ScalarField",
            "name": "categoryIds"
          },
          {
            "kind": "ScalarField",
            "name": "keywords"
          },
          {
            "kind": "ScalarField",
            "name": "recommendationRank"
          },
          {
            "kind": "ScalarField",
            "name": "author"
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          }
        ]
      }
    ]
  },
  {
    "condition": "isLicensed",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "concreteType": "UserPreferences",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "favouriteTemplateEntityIds"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TemplateListCurrentSpaceQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "TemplateListCurrentSpaceQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "05a2ed7d721b148ddc8e144174362983",
    "id": "51c1ca272a2d8244b60ffb536d476ff6d2c010a24bf4a1a173cf9df601a5ce72",
    "metadata": {},
    "name": "TemplateListCurrentSpaceQuery",
    "operationKind": "query",
    "text": "query TemplateListCurrentSpaceQuery($spaceKey:String!,$sortingScheme:String,$isLicensed:Boolean!,$teamType:String)@allowHigherTimeout{allTemplates(spaceKey:$spaceKey,sortingScheme:$sortingScheme,teamType:$teamType){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author},pageInfo{hasNextPage}},userPreferences@include(if:$isLicensed){favouriteTemplateEntityIds}}"
  }
};
})();

(node as any).hash = "6ad6c9c0ffba14980f625117a309dd12";

export default node;
